// Vietnamese (vi) dictionary for Life Leverage OS.
// Mirrors the English key structure 1:1 (verified by scripts/check-i18n-parity.js).
// Product names ("Life Leverage OS", "Premium", "AI") are kept as-is.
// Enum VALUES stay canonical English in the database; only display labels are translated.

export const vi = {
  common: {
    save: 'Lưu',
    saveChanges: 'Lưu thay đổi',
    cancel: 'Hủy',
    delete: 'Xóa',
    remove: 'Gỡ bỏ',
    edit: 'Chỉnh sửa',
    open: 'Mở',
    add: 'Thêm',
    none: 'Không có',
    select: 'Chọn',
    progress: 'Tiến độ',
    next: 'Tiếp theo:',
    cannotUndo: 'Thao tác này không thể hoàn tác.',
    loading: 'Đang tải…',
  },
  nav: {
    dashboard: 'Hôm nay',
    goals: 'Mục tiêu',
    tasks: 'Công việc',
    projects: 'Dự án',
    ai: 'Trợ lý',
  },
  more: {
    finance: 'Tài chính',
    habits: 'Thói quen',
    review: 'Tổng kết ngày',
    settings: 'Cài đặt',
  },
  screens: {
    dashboard: 'Hôm nay',
    goals: 'Mục tiêu',
    tasks: 'Công việc',
    projects: 'Dự án',
    finance: 'Tài chính',
    habits: 'Thói quen',
    review: 'Tổng kết ngày',
    settings: 'Cài đặt',
  },
  language: {
    label: 'Ngôn ngữ',
    switch: 'Đổi ngôn ngữ',
  },
  legal: {
    notice: 'Các tài liệu pháp lý hiện chỉ có bằng tiếng Ba Lan và tiếng Anh.',
    backToApp: 'Quay lại ứng dụng',
    website: 'Trang web:',
    contact: 'Liên hệ:',
  },
  onboarding: {
    title: 'Biến sự rối bời thành kế hoạch rõ ràng cho hôm nay.',
    subtitle: 'Trung tâm điều hành cá nhân cho mục tiêu, công việc, tiền bạc, thói quen và hành động mỗi ngày.',
    chipGoals: 'Mục tiêu',
    chipMoney: 'Tiền bạc',
    chipHabits: 'Thói quen',
    getStarted: 'Bắt đầu',
    demo: 'Dùng thử với tài khoản demo',
    tagline: 'Bình tĩnh. Tập trung. Giúp bạn luôn biết bước tiếp theo.',
    demoWelcome: 'Chào mừng Marek — không gian demo của bạn đã sẵn sàng.',
    demoError: 'Không thể khởi động bản demo. Vui lòng thử lại.',
  },
  auth: {
    signupTitle: 'Tạo tài khoản',
    loginTitle: 'Chào mừng trở lại',
    signupSubtitle: 'Bắt đầu sắp xếp cuộc sống của bạn ở một nơi gọn gàng.',
    loginSubtitle: 'Đăng nhập để tiếp tục với trung tâm điều hành của bạn.',
    name: 'Họ tên',
    namePlaceholder: 'Tên của bạn',
    email: 'Email',
    emailPlaceholder: 'ban@vidu.vn',
    password: 'Mật khẩu',
    createAccount: 'Tạo tài khoản',
    login: 'Đăng nhập',
    or: 'hoặc',
    demo: 'Dùng thử với tài khoản demo',
    haveAccount: 'Đã có tài khoản?',
    noAccount: 'Chưa có tài khoản?',
    signup: 'Đăng ký',
    fillFields: 'Vui lòng điền đầy đủ thông tin.',
    accountCreated: 'Đã tạo tài khoản. Chào mừng bạn!',
    welcomeBack: 'Chào mừng trở lại!',
    genericError: 'Đã xảy ra lỗi. Vui lòng thử lại.',
    demoReady: 'Không gian demo đã sẵn sàng.',
    demoError: 'Không thể khởi động bản demo.',
  },
  dashboard: {
    subGreeting: 'Hãy tập trung vào điều quan trọng hôm nay.',
    mainFocusEyebrow: 'Trọng tâm hôm nay',
    startNow: 'Bắt đầu ngay',
    topPriorities: '3 ưu tiên hàng đầu',
    allTasks: 'Tất cả công việc',
    topPrioritiesEmpty: 'Không có công việc nào đang mở. Tận hưởng phút giây thư thái hoặc thêm một việc mới.',
    noDate: 'Chưa có ngày',
    activeGoals: 'Mục tiêu đang theo đuổi',
    allGoals: 'Tất cả mục tiêu',
    goalsEmpty: 'Chưa có mục tiêu nào đang hoạt động.',
    projectsTitle: 'Dự án cần chú ý',
    allProjects: 'Tất cả dự án',
    projectsEmpty: 'Hiện không có gì cần chú ý.',
    financeTitle: 'Tổng quan tài chính',
    income: 'Thu nhập',
    expenses: 'Chi tiêu',
    remaining: 'Còn lại',
    monthlyIncomeGoal: 'Mục tiêu thu nhập tháng',
    habitsTitle: 'Thói quen hôm nay',
    allHabits: 'Tất cả thói quen',
    habitsEmpty: 'Chưa có thói quen nào.',
    aiNextStep: 'Bước tiếp theo từ AI',
    askAssistant: 'Hỏi Trợ lý',
    loader: 'Đang chuẩn bị ngày của bạn…',
    loadError: 'Không thể tải bảng điều khiển.',
    taskDone: 'Tuyệt. Xong thêm một bước.',
    taskError: 'Không thể cập nhật công việc.',
    habitError: 'Không thể cập nhật thói quen.',
  },
  goals: {
    title: 'Mục tiêu',
    subtitle: 'Điều bạn đang hướng tới',
    emptyTitle: 'Chưa có mục tiêu nào',
    emptySubtitle: 'Tạo một mục tiêu để mỗi ngày có định hướng.',
    addFab: 'Thêm mục tiêu',
    loader: 'Đang tải mục tiêu…',
    loadError: 'Không thể tải mục tiêu.',
    steps: '{done}/{total} bước',
    deadline: 'Hạn chót: {date}',
    editTitle: 'Chỉnh sửa mục tiêu',
    newTitle: 'Mục tiêu mới',
    create: 'Tạo mục tiêu',
    fieldTitle: 'Tiêu đề',
    titlePlaceholder: 'VD: Xây dựng portfolio ứng dụng AI',
    category: 'Danh mục',
    status: 'Trạng thái',
    description: 'Mô tả',
    descriptionPlaceholder: 'Thành công trông như thế nào?',
    deadlineField: 'Hạn chót',
    progress: 'Tiến độ · {n}%',
    actionSteps: 'Các bước hành động',
    stepPlaceholder: 'Thêm một bước hành động',
    complete: 'Hoàn thành',
    confirmTitle: 'Xóa mục tiêu này?',
    titleRequired: 'Vui lòng nhập tiêu đề mục tiêu.',
    updated: 'Đã cập nhật mục tiêu.',
    created: 'Đã tạo mục tiêu.',
    saveError: 'Không thể lưu mục tiêu.',
    completed: 'Mục tiêu đã hoàn thành. Làm tốt lắm!',
    updateError: 'Không thể cập nhật mục tiêu.',
    deleted: 'Đã xóa mục tiêu.',
    deleteError: 'Không thể xóa mục tiêu.',
  },
  tasks: {
    title: 'Công việc',
    subtitle: 'Tập trung vào vài việc quan trọng hôm nay',
    emptyCompletedTitle: 'Chưa có việc nào hoàn thành',
    emptyTitle: 'Không có công việc nào ở đây',
    emptyTodaySubtitle: 'Một ngày nhẹ nhàng. Thêm việc mới hoặc nghỉ ngơi.',
    emptySubtitle: 'Thêm công việc để lên kế hoạch trước.',
    addFab: 'Thêm công việc',
    loader: 'Đang tải công việc…',
    loadError: 'Không thể tải công việc.',
    editTitle: 'Chỉnh sửa công việc',
    newTitle: 'Công việc mới',
    addTask: 'Thêm công việc',
    fieldTitle: 'Tiêu đề',
    titlePlaceholder: 'VD: Gửi 10 tin nhắn tiếp cận khách hàng',
    description: 'Mô tả',
    descriptionPlaceholder: 'Chi tiết (không bắt buộc)',
    priority: 'Mức ưu tiên',
    status: 'Trạng thái',
    dueDate: 'Hạn hoàn thành',
    relatedGoal: 'Mục tiêu liên quan',
    relatedProject: 'Dự án liên quan',
    deleteTask: 'Xóa công việc',
    confirmTitle: 'Xóa công việc này?',
    titleRequired: 'Vui lòng nhập tiêu đề công việc.',
    updated: 'Đã cập nhật công việc.',
    added: 'Đã thêm công việc.',
    saveError: 'Không thể lưu công việc.',
    done: 'Xong. Giữ vững đà này nhé.',
    updateError: 'Không thể cập nhật công việc.',
    deleted: 'Đã xóa công việc.',
    deleteError: 'Không thể xóa công việc.',
  },
  projects: {
    title: 'Dự án',
    subtitle: 'Giữ đà cho những việc quan trọng',
    emptyTitle: 'Không có dự án nào ở đây',
    emptySubtitle: 'Tạo một dự án để sắp xếp công việc của bạn.',
    addFab: 'Thêm dự án',
    loader: 'Đang tải dự án…',
    loadError: 'Không thể tải dự án.',
    editTitle: 'Chỉnh sửa dự án',
    newTitle: 'Dự án mới',
    create: 'Tạo dự án',
    name: 'Tên dự án',
    namePlaceholder: 'VD: Tiếp cận đối tác tại Dubai 2026',
    category: 'Danh mục',
    status: 'Trạng thái',
    description: 'Mô tả',
    descriptionPlaceholder: 'Dự án này nói về điều gì?',
    nextAction: 'Hành động tiếp theo',
    nextActionPlaceholder: 'Bước tiếp theo duy nhất',
    progress: 'Tiến độ · {n}%',
    deleteProject: 'Xóa dự án',
    confirmTitle: 'Xóa dự án này?',
    confirmDesc: 'Các công việc liên kết sẽ được giữ lại nhưng bỏ liên kết.',
    nameRequired: 'Vui lòng nhập tên dự án.',
    updated: 'Đã cập nhật dự án.',
    created: 'Đã tạo dự án.',
    saveError: 'Không thể lưu dự án.',
    deleted: 'Đã xóa dự án.',
    deleteError: 'Không thể xóa dự án.',
  },
  projectDetail: {
    title: 'Dự án',
    notFoundTitle: 'Không tìm thấy dự án',
    notFoundSubtitle: 'Có thể dự án đã bị xóa.',
    nextActionLabel: 'Hành động tiếp theo',
    nextActionEmpty: 'Xác định bước tiếp theo duy nhất.',
    tasksHeading: 'Công việc',
    addTask: 'Thêm công việc',
    tasksEmptyTitle: 'Chưa có công việc nào',
    tasksEmptySubtitle: 'Chia dự án này thành các bước nhỏ.',
    drawerTitle: 'Thêm công việc vào dự án',
    fieldTitle: 'Tiêu đề',
    titlePlaceholder: 'Cần làm gì?',
    priority: 'Mức ưu tiên',
    loader: 'Đang tải dự án…',
    loadError: 'Không thể tải dự án.',
    updateError: 'Không thể cập nhật công việc.',
    titleRequired: 'Vui lòng nhập tiêu đề công việc.',
    added: 'Đã thêm công việc vào dự án.',
    addError: 'Không thể thêm công việc.',
  },
  finance: {
    title: 'Tài chính',
    subtitle: 'Kiểm soát tiền bạc đơn giản',
    monthlyGoal: 'Mục tiêu tháng',
    income: 'Thu nhập',
    expenses: 'Chi tiêu',
    remaining: 'Còn lại',
    incomeGoalProgress: 'Tiến độ mục tiêu thu nhập',
    nextMoneyAction: 'Hành động tài chính tiếp theo',
    recent: 'Giao dịch gần đây',
    emptyTitle: 'Chưa có giao dịch nào',
    emptySubtitle: 'Thêm khoản thu, khoản chi hoặc nhắc nhở thanh toán.',
    addFab: 'Thêm giao dịch',
    loader: 'Đang tải tài chính…',
    loadError: 'Không thể tải dữ liệu tài chính.',
    drawerTitle: 'Thêm mục tài chính',
    type: 'Loại',
    fieldTitle: 'Tiêu đề',
    titlePlaceholder: 'VD: Phí dịch vụ khách hàng hằng tháng',
    amount: 'Số tiền (PLN)',
    date: 'Ngày',
    confirmTitle: 'Xóa mục này?',
    invalid: 'Vui lòng nhập tiêu đề và số tiền hợp lệ.',
    saved: 'Đã lưu.',
    saveError: 'Không thể lưu mục này.',
    deleted: 'Đã xóa.',
    deleteError: 'Không thể xóa mục này.',
  },
  habits: {
    title: 'Thói quen',
    subtitle: 'Hôm nay đã xong {done}/{total}',
    today: 'Hôm nay',
    emptyTitle: 'Chưa có thói quen nào',
    emptySubtitle: 'Tạo đà bằng một thói quen nhỏ mỗi ngày.',
    addFab: 'Thêm thói quen',
    loader: 'Đang tải thói quen…',
    loadError: 'Không thể tải thói quen.',
    drawerTitle: 'Thói quen mới',
    name: 'Tên thói quen',
    namePlaceholder: 'VD: 30 phút làm việc tập trung',
    category: 'Danh mục',
    frequency: 'Tần suất',
    addHabit: 'Thêm thói quen',
    confirmTitle: 'Gỡ bỏ thói quen này?',
    confirmDesc: 'Chuỗi ngày liên tiếp của bạn sẽ bị mất.',
    doneToday: 'Đã hoàn thành “{name}” hôm nay.',
    updateError: 'Không thể cập nhật thói quen.',
    nameRequired: 'Vui lòng nhập tên thói quen.',
    added: 'Đã thêm thói quen.',
    saveError: 'Không thể lưu thói quen.',
    removed: 'Đã gỡ bỏ thói quen.',
    deleteError: 'Không thể xóa thói quen.',
  },
  ai: {
    title: 'Trợ lý cuộc sống AI',
    subtitle: 'Người hướng dẫn trong ứng dụng',
    prompt1: 'Hôm nay tôi nên tập trung vào điều gì?',
    prompt2: 'Tôi không biết bắt đầu từ đâu.',
    prompt3: 'Tôi có quá nhiều việc. Giúp tôi chọn.',
    prompt4: 'Chia mục tiêu chính của tôi thành các bước.',
    prompt5: 'Ứng dụng này giúp được gì cho tôi?',
    emptyTitle: 'Hôm nay tôi có thể giúp gì cho bạn?',
    orientation: 'Tôi có thể giúp bạn quyết định việc cần làm hôm nay, sắp xếp một mục tiêu, dự án hoặc công việc, hoặc chỉ cho bạn nơi tìm các tính năng trong Life Leverage OS.',
    emptySubtitle: 'Tôi dựa trên các mục tiêu, công việc, dự án, thói quen và tài chính đã có trong tài khoản của bạn. Tôi không bao giờ tự ý thay đổi gì.',
    mainPriority: 'Quan trọng nhất lúc này',
    nextSteps: 'Các bước tiếp theo',
    clarifyLabel: 'Câu hỏi nhanh',
    goTo: 'Đi tới:',
    suggestedTask: 'Công việc gợi ý',
    add: 'Thêm',
    thinking: 'Đang suy nghĩ…',
    assistant: 'Trợ lý',
    composerPlaceholder: 'Hãy nói cho tôi điều bạn đang nghĩ…',
    loader: 'Đang khởi động trợ lý…',
    loadError: 'Không thể tải cuộc trò chuyện.',
    respondError: 'Trợ lý không thể phản hồi. Vui lòng thử lại.',
    taskAdded: 'Đã thêm vào công việc hôm nay của bạn.',
    taskAddError: 'Không thể thêm công việc.',
  },
  review: {
    title: 'Tổng kết ngày',
    subtitle: 'Khép lại ngày một cách rõ ràng',
    tasksDone: 'Công việc đã xong',
    habitsDone: 'Thói quen đã xong',
    tomorrowLabel: 'Trọng tâm gợi ý cho ngày mai',
    qCompletedLabel: 'Hôm nay tôi đã hoàn thành gì?',
    qCompletedPlaceholder: 'Liệt kê những gì bạn đã làm xong…',
    qReflectionLabel: 'Điều gì đã giúp cuộc sống tôi tiến lên?',
    qReflectionPlaceholder: 'Dù chỉ một điều nhỏ cũng đáng kể…',
    qDifficultyLabel: 'Điều gì khó khăn?',
    qDifficultyPlaceholder: 'Gọi tên nó, rồi buông bỏ…',
    qTomorrowLabel: 'Một ưu tiên cho ngày mai là gì?',
    qTomorrowPlaceholder: 'Trọng tâm quan trọng nhất của bạn…',
    savedBanner: 'Đã lưu tổng kết hôm nay',
    update: 'Cập nhật tổng kết',
    save: 'Lưu tổng kết',
    loader: 'Đang tải ngày của bạn…',
    loadError: 'Không thể tải bản tổng kết.',
    saved: 'Đã lưu tổng kết. Nghỉ ngơi thật tốt nhé.',
    saveError: 'Không thể lưu tổng kết.',
  },
  settings: {
    title: 'Cài đặt',
    subtitle: 'Hồ sơ & tùy chọn của bạn',
    yourName: 'Tên của bạn',
    name: 'Họ tên',
    email: 'Email',
    incomeGoal: 'Mục tiêu thu nhập tháng (PLN)',
    focus: 'Trọng tâm chính trong cuộc sống',
    focusPlaceholder: 'Bạn đang hướng tới điều gì?',
    planning: 'Phong cách lập kế hoạch mỗi ngày',
    planningPlaceholder: 'VD: Làm việc sâu, tập trung',
    notifications: 'Thông báo',
    languageRow: 'Ngôn ngữ',
    premiumTitle: 'Premium — sắp ra mắt',
    premiumText: 'Các tính năng Premium được lên kế hoạch cho phiên bản tương lai của Life Leverage OS. Trong giai đoạn thử nghiệm kín, bạn có thể dùng hệ thống hiện tại cho mục tiêu, công việc, dự án, thói quen, trọng tâm, tổng quan tài chính và trợ lý AI.',
    premiumBadge: 'Sắp ra mắt',
    save: 'Lưu thay đổi',
    logout: 'Đăng xuất',
    updated: 'Đã cập nhật hồ sơ.',
    saveError: 'Không thể lưu hồ sơ.',
  },
  enums: {
    Business: 'Kinh doanh',
    Finance: 'Tài chính',
    Health: 'Sức khỏe',
    Personal: 'Cá nhân',
    Learning: 'Học tập',
    Relationships: 'Các mối quan hệ',
    'Spiritual / Mindset': 'Tinh thần / Tư duy',
    'App Development': 'Phát triển ứng dụng',
    eBook: 'eBook',
    Sales: 'Bán hàng',
    Work: 'Công việc',
    Mindset: 'Tư duy',
    All: 'Tất cả',
    Active: 'Đang hoạt động',
    'In Progress': 'Đang thực hiện',
    Paused: 'Tạm dừng',
    Completed: 'Đã hoàn thành',
    Planning: 'Đang lên kế hoạch',
    Waiting: 'Đang chờ',
    'To Do': 'Cần làm',
    Done: 'Xong',
    Today: 'Hôm nay',
    Upcoming: 'Sắp tới',
    Low: 'Thấp',
    Medium: 'Trung bình',
    High: 'Cao',
    Critical: 'Khẩn cấp',
    income: 'Thu nhập',
    expense: 'Chi tiêu',
    payment: 'Thanh toán',
    Daily: 'Hằng ngày',
    Weekdays: 'Ngày trong tuần',
    Weekly: 'Hằng tuần',
  },
};
